'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLevel = undefined;
exports.create = create;

var _loglevel = require('loglevel');

var _loglevel2 = _interopRequireDefault(_loglevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var methods = ['trace', 'debug', 'info', 'warn', 'error'];

function getDate() {
    return new Date();
}

function log(level, prefix) {
    var logLevel = level.toUpperCase();
    return function (msg) {
        _loglevel2.default[level](getDate() + '|' + logLevel + '|' + prefix + '|' + msg);
    };
}

function create(classname) {
    return methods.reduce(function (aggr, method) {
        return Object.assign(_defineProperty({}, method, log(method, classname)), aggr);
    }, {});
}

var setLevel = exports.setLevel = _loglevel2.default.setLevel;


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/logger.js
// module id = 223
// module chunks = 1